export default Object.freeze({
  Generic: 0,
  App: 1,
  Process: 2,
  Chat: 3,
});
